"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _layer = require("ol/layer");

var _style = require("ol/style");

var _source = require("ol/source");

var _proj = require("ol/proj");

var _geom = require("ol/geom");

var _interaction = require("ol/interaction");

var _extent = require("ol/extent");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * <p>The Overview Map Control.</p>
 * <p>
 * 	This control has a view in a large area of the map,
 * 	allowing a better map navigation,
 * 	The box present in the overview map represents the area of the parent view.
 * 	This control has the following properties:
 * </p>
 * <ol>
 * <li>If the user pan the overview map, the parent map will also be re-centered accordinlgy.</li>
 * <li>If the user pan the parent the map, the overview map will be re-centered accordingly.</li>
 * <li>If the user click a point in the overview map:</li>
 * <ul>
 *    <li>The overview map will be re-centered in the clicked point</li>
 *    <li>The parent map will be re-centered accordingly</li>
 * </ul>
 * </ol>
 * 
 * @visibleName Map Overview
 */
var MapOverviewWidget = function MapOverviewWidget(_ref) {
  var map = _ref.map,
      parentMap = _ref.parentMap,
      _ref$anchorStyle = _ref.anchorStyle,
      anchorStyle = _ref$anchorStyle === void 0 ? null : _ref$anchorStyle,
      _ref$boxStyle = _ref.boxStyle,
      boxStyle = _ref$boxStyle === void 0 ? null : _ref$boxStyle,
      _ref$magnification = _ref.magnification,
      magnification = _ref$magnification === void 0 ? 5 : _ref$magnification,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "100%" : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width;
  //const parentMap = useContext(MapContext).map;
  var childMapRef = (0, _react.useRef)();
  var childMap = (0, _react.useState)(map)[0];
  var boxFeature = (0, _react.useState)(new _ol.Feature())[0];
  var anchorFeature = (0, _react.useState)(new _ol.Feature())[0];
  var extentLayer = (0, _react.useState)(new _layer.Vector({
    source: new _source.Vector()
  }))[0];

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      dragInteraction = _useState2[0],
      setDragInteraction = _useState2[1];
  /**
   * Set an OverviewMap property (center or resolution).
   * 
   * @param {String} key The name of the property, either 'center' or 'resolution'
   */


  var setOverviewMapProperty = (0, _react.useCallback)(function (key) {
    if (!childMap) return;
    var parentView = parentMap.getView();
    var parentProjection = parentView.getProjection();
    var overviewView = childMap.getView();
    var overviewProjection = overviewView.getProjection();
    var overviewCenter = parentView.getCenter();

    if (key === 'center') {
      // transform if necessary
      if (!(0, _proj.equivalent)(parentProjection, overviewProjection)) {
        overviewCenter = (0, _proj.transform)(overviewCenter, parentProjection, overviewProjection);
      }

      overviewView.set('center', overviewCenter);
    }

    if (key === 'resolution') {
      if ((0, _proj.equivalent)(parentProjection, overviewProjection)) {
        overviewView.set('resolution', magnification * parentView.getResolution());
      } else {
        var parentExtent = parentView.calculateExtent(parentMap.getSize());
        var parentExtentProjected = (0, _proj.transformExtent)(parentExtent, parentProjection, overviewProjection);
        overviewView.fit(parentExtentProjected, {
          constrainResolution: false
        });
        overviewView.set('resolution', magnification() * overviewView.getResolution());
      } // Do nothing when parent and overview projections are not
      // equivalent as me.getMap().getSize()
      // would not be reliable here.

    }
  }, [childMap, parentMap, magnification]);
  /**
   * Called when a property of the parent map view Changes
   */

  var onParentViewPropChange = (0, _react.useCallback)(function (evt) {
    if (evt.key === 'center' || evt.key === 'resolution') {
      setOverviewMapProperty(evt.key);
    }
  }, [setOverviewMapProperty]);
  var updateBox = (0, _react.useCallback)(function () {
    if (!childMap) return;
    var extentGeometries = getVisibleExtentGeometries(parentMap);

    if (!extentGeometries) {
      return;
    }

    var geom = extentGeometries.extent;
    var anchor = extentGeometries.topLeft;
    var parentMapProjection = parentMap.getView().getProjection();
    var overviewProjection = childMap.getView().getProjection(); // transform if necessary

    if (!(0, _proj.equivalent)(parentMapProjection, overviewProjection)) {
      geom.transform(parentMapProjection, overviewProjection);
      anchor.transform(parentMapProjection, overviewProjection);
    }

    boxFeature.setGeometry(geom);
    anchorFeature.setGeometry(anchor);
  }, [childMap, parentMap, boxFeature, anchorFeature]);
  /**
   * Enables the update of the box by biding the updateBox function
   * to the postrender event of the parent map
   */

  var enableBoxUpdate = (0, _react.useCallback)(function () {
    if (parentMap) {
      parentMap.on('postrender', updateBox);
    }
  }, [parentMap, updateBox]);
  var disableBoxUpdate = (0, _react.useCallback)(function () {
    if (parentMap) {
      parentMap.un('postrender', updateBox);
    }
  }, [parentMap, updateBox]);
  /**
   * Repositions the #anchorFeature during dragging sequences of the box.
   * Called while the #boxFeature is being dragged.
   */

  var repositionAnchorFeature = (0, _react.useCallback)(function () {
    var boxCoords = boxFeature.getGeometry().getCoordinates();
    var topLeftCoord = boxCoords[0][0];
    var newAnchorGeom = new _geom.Point(topLeftCoord);
    anchorFeature.setGeometry(newAnchorGeom);
  }, [anchorFeature, boxFeature]);
  /**
   * Recenters the #parentMap to the center of the extent of the #boxFeature.
   * Called when dragging of the #boxFeature ends.
   */

  var recenterParentFromBox = (0, _react.useCallback)(function () {
    if (!childMap) return;
    var parentView = parentMap.getView();
    var parentProjection = parentView.getProjection();
    var overviewView = childMap.getView();
    var overviewProjection = overviewView.getProjection(); //const currentMapCenter = parentView.getCenter();

    var boxExtent = boxFeature.getGeometry().getExtent();
    var boxCenter = (0, _extent.getCenter)(boxExtent); // transform if necessary

    if (!(0, _proj.equivalent)(parentProjection, overviewProjection)) {
      boxCenter = (0, _proj.transform)(boxCenter, overviewProjection, parentProjection);
    }

    parentView.animate({
      center: boxCenter
    });
  }, [parentMap, childMap, boxFeature]);
  /**
   * Enable everything we need to be able to drag the extent box on the
   * overview map, and to properly handle drag events (e.g. recenter on
   * finished dragging).
   */

  var setupDragBehaviour = (0, _react.useCallback)(function () {
    if (!childMap) return;

    if (!dragInteraction) {
      var newDragInteraction = new _interaction.Translate({
        features: new _ol.Collection([boxFeature])
      });
      childMap.addInteraction(newDragInteraction);
      newDragInteraction.setActive(true); // disable the box update during the translation
      // because it interferes when dragging the feature

      newDragInteraction.on('translatestart', disableBoxUpdate);
      newDragInteraction.on('translating', repositionAnchorFeature);
      newDragInteraction.on('translateend', recenterParentFromBox);
      newDragInteraction.on('translateend', enableBoxUpdate);
      setDragInteraction(newDragInteraction);
    }
  }, [boxFeature, childMap, enableBoxUpdate, dragInteraction, disableBoxUpdate, repositionAnchorFeature, recenterParentFromBox]);
  /**
   * Disable / destroy everything we need to be able to drag the extent box on
   * the overview map. Unregisters any events we might have added and removes
   * the `ol.interaction.Translate`.
   */

  var destroyDragBehaviour = (0, _react.useCallback)(function () {
    if (!childMap) return;

    if (!dragInteraction) {
      return;
    }

    dragInteraction.setActive(false);
    childMap.removeInteraction(dragInteraction);
    dragInteraction.un('translatestart', disableBoxUpdate);
    dragInteraction.un('translating', repositionAnchorFeature);
    dragInteraction.un('translateend', recenterParentFromBox);
    dragInteraction.un('translateend', enableBoxUpdate);
    setDragInteraction(null);
  }, [dragInteraction, childMap, disableBoxUpdate, repositionAnchorFeature, recenterParentFromBox, enableBoxUpdate]);
  /**
   * Handler for the click event of the overview map. Recenters the parent
   * map to the clicked location.
   *
   * @param {ol.MapBrowserEvent} evt The click event on the map.
   * @private
   */

  var overviewMapClicked = (0, _react.useCallback)(function (evt) {
    if (!childMap) return;
    var parentView = parentMap.getView();
    var parentProjection = parentView.getProjection(); //const currentMapCenter = parentView.getCenter();

    var overviewView = childMap.getView();
    var overviewProjection = overviewView.getProjection();
    var newCenter = evt.coordinate; // transform if necessary

    if (!(0, _proj.equivalent)(parentProjection, overviewProjection)) {
      newCenter = (0, _proj.transform)(newCenter, overviewProjection, parentProjection);
    }

    parentView.animate({
      center: newCenter
    });
  }, [childMap, parentMap]);
  /**
   * Handler to update center/zoom of the overview map if the size of
   * the window is changed.
   */

  var resizeWindowHandler = (0, _react.useCallback)(function (e) {
    if (!childMap) return;
    childMap.updateSize();
    setOverviewMapProperty('resolution');
    setOverviewMapProperty('center');
  }, [setOverviewMapProperty, childMap]);
  /**
   * Initialize the child overview map
   */

  (0, _react.useEffect)(function () {
    if (!childMap) return;
    childMap.addLayer(extentLayer);
    childMap.setTarget(childMapRef.current);
    setOverviewMapProperty('resolution');
    window.addEventListener("resize", resizeWindowHandler);
    return function () {
      if (childMap) {
        childMap.removeLayer(extentLayer);
        childMap.setTarget(undefined);
        window.removeEventListener("resize", resizeWindowHandler);
      }
    };
  }, [childMap, extentLayer, setOverviewMapProperty, resizeWindowHandler]);
  /**
   * Set Event Handler to change the center or resolution of the child overview map
   * if the center or resolution in parent map changes
   */

  (0, _react.useEffect)(function () {
    parentMap.getView().on('propertychange', onParentViewPropChange);
    return function () {
      parentMap.getView().un('propertychange', onParentViewPropChange);
    };
  }, [parentMap, onParentViewPropChange]);
  /**
   * Set 'postrender' event handler update the box/anchor in the child overview map 
   * after rendering a new frame of the parent map
   */

  (0, _react.useEffect)(function () {
    enableBoxUpdate(); //return cleanup function

    return function () {
      return disableBoxUpdate();
    };
  }, [enableBoxUpdate, disableBoxUpdate]);
  /**
   * Initially set the center and resolution of the overview map
   */

  (0, _react.useEffect)(function () {
    setOverviewMapProperty('center');
    setOverviewMapProperty('resolution');
  }, [setOverviewMapProperty]);
  /**
   * Add the box and anchor features into the extent layer of the 
   * child overview map
   */

  (0, _react.useEffect)(function () {
    extentLayer.getSource().addFeatures([boxFeature, anchorFeature]);

    if (anchorStyle) {
      anchorFeature.setStyle(anchorStyle);
    }

    if (boxStyle) {
      boxFeature.setStyle(boxStyle);
    }
  }, [extentLayer, anchorFeature, boxFeature, boxStyle, anchorStyle]);
  /**
   * Enable everything we need to be able to drag the extent box on the
   * overview map, and to properly handle drag events (e.g. recenter on
   * finished dragging).
   */

  (0, _react.useEffect)(function () {
    setupDragBehaviour();
    return function () {
      return destroyDragBehaviour();
    };
  }, [setupDragBehaviour, destroyDragBehaviour]);
  /**
   * Set the event handler to recenter the overview map if the user clicks on it
   */

  (0, _react.useEffect)(function () {
    if (!childMap) return;
    childMap.on('click', overviewMapClicked);
    return function () {
      return childMap.un('click', overviewMapClicked);
    };
  }, [childMap, overviewMapClicked]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: childMapRef,
    style: {
      height: height,
      width: width
    }
  });
};

var getVisibleExtentGeometries = function getVisibleExtentGeometries(map) {
  var mapSize = map && map.getSize();
  var w = mapSize && mapSize[0];
  var h = mapSize && mapSize[1];

  if (!mapSize || isNaN(w) || isNaN(h)) {
    return;
  }

  var pixels = [[0, 0], [w, 0], [w, h], [0, h], [0, 0]];
  var extentCoords = [];
  pixels.forEach(function (pixel) {
    var coord = map.getCoordinateFromPixel(pixel);

    if (coord === null) {
      return false;
    }

    extentCoords.push(coord);
  });

  if (extentCoords.length !== 5) {
    return;
  }

  var geom = new _geom.Polygon([extentCoords]);
  var anchor = new _geom.Point(extentCoords[0]);
  return {
    extent: geom,
    topLeft: anchor
  };
};

MapOverviewWidget.propTypes = {
  /**
   * The OpenLayers ol/Map
   */
  map: _propTypes.default.instanceOf(_ol.Map).isRequired,

  /**
   * The height of the map.
   */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The width of the map.
   */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The ol/style/Style for the anchor feature which indicates the upper-left
   * corner of the overview rectangle.
   */
  anchorStyle: _propTypes.default.instanceOf(_style.Style),

  /**
   * The ol/style/Style for the overview rectangle.
   */
  boxStyle: _propTypes.default.instanceOf(_style.Style),

  /**
   * The magnification of the overview map.
   * The maginification represent how many times
   * the scale of the parent map is bigger than the
   * the scale of the overview map.
   */
  magnification: _propTypes.default.number
};
var _default = MapOverviewWidget;
exports.default = _default;